import LiveStatusBadge from "../../../../Component/UI/LiveStatusBadge";
import { useEffect, useState } from "react";
import styled from "styled-components";
import {
  RowView,
  RowView2,
  CenterView,
} from "../../../../Component/style/common_style";
import { amountFormat } from "../../../../Component/tool/Tools";
import { useNavigate } from "react-router-dom";
import { LiveListItem } from "../../../../Component/Interface/Live";
import api from "../../../../Component/axios_Interceptor/api";
import url, { SERVER_ADDRESS } from "../../../../Component/server";
import LiveCardPreview from "./LiveCardPreview";
import ReviewCardPreview from "./ReviewCardPreview";

interface LiveListProps {
  liveList: LiveListItem[];
  isLive: boolean;
  search_live: (text: string) => void;
  search?: string;
  isLogin: boolean;
  follow?: string;
  hideStoreInfo?: boolean;
}

const LiveList = ({
  liveList,
  isLive,
  search_live,
  search,
  isLogin,
  follow,
  hideStoreInfo,
}: LiveListProps) => {
  const Navigate = useNavigate();

  // 팔로우
  const store_follow = async (store_seq: number) => {
    try {
      const res = await api.post(url.Communication_url.store_follow, {
        store_seq: store_seq,
      });
    } catch (error) {
      console.log(error);
    } finally {
      search_live(search || "");
    }
  };

  const store_unfollow = async (store_seq: number) => {
    try {
      const res = await api.delete(url.Communication_url.store_unfollow, {
        data: {
          store_seq: store_seq,
        },
      });
    } catch (error) {
      console.log(error);
    } finally {
      search_live(search || "");
    }
  };

  const go_live = async (item: LiveListItem) => {
    const review = Number(item.payment_review_enabled) === 1 && item.live_status !== "방송중";
    if (review || item.viewer_count < Number(item.live_limit)) {
      Navigate(review ? `/payment-review/live/${item.seq}` : `/live/${item.seq}`, {
        state: { check: "check" },
      });
    } else {
      alert("시청 가능 인원이 초과되었습니다.");
    }
  };

  return (
    <LiveListDiv>
      {liveList.length > 0 &&
        liveList.map((item) => {
          const review = Number(item.payment_review_enabled) === 1 && item.live_status !== "방송중";
          return (
            <div key={item.seq}>
              <Thimbnail
                $isLive={isLive}
                role={isLive ? "link" : undefined}
                tabIndex={isLive ? 0 : undefined}
                aria-label={isLive ? `${item.live_title} 라이브 보기` : undefined}
                style={{
                  backgroundImage: review ? "none" : `url(${
                    item.live_img && item.live_img.trim() !== ""
                      ? SERVER_ADDRESS + "openfile/" + item.live_img
                      : require("../../../../Image/image_thimbnail_base.png")
                  })`,
                  backgroundColor: review ? "#050505" : undefined,
                }}
                onClick={() => { if (isLive) void go_live(item); }}
                onKeyDown={event => { if (isLive && (event.key === "Enter" || event.key === " ")) { event.preventDefault(); void go_live(item); } }}
              >
                {isLive && review && <ReviewCardPreview />}
                {isLive && item.live_status === "방송중" && !review && <LiveCardPreview liveSeq={item.seq} isLogin={isLogin} />}
                <CardOverlay>
                <RowView2>
                  <LiveStatusBadge status={item.live_status} />
                  {isLive && (
                    <ViewCount>
                      {amountFormat(item.viewer_count)}명 시청
                    </ViewCount>
                  )}
                </RowView2>
                <Title>{item.live_title}</Title>
                </CardOverlay>
              </Thimbnail>
              {!hideStoreInfo && (
                <StoreInfo>
                  <ProfileDiv
                    style={{ cursor: "pointer" }}
                    onClick={(e) => {
                      e.stopPropagation();
                      if (item.store_seq) {
                        Navigate(`/store/${item.store_seq}`);
                      }
                    }}
                  >
                    <ProfileImage
                      src={
                        item.store.profile_img === ""
                          ? require("../../../../Image/Logo.png")
                          : SERVER_ADDRESS + "openfile/" + item.store.profile_img
                      }
                    />
                    <Nickname>{item.store.store_name}</Nickname>
                  </ProfileDiv>
                  {isLogin && (
                    <FollowBtn
                      $isFollowing={item.follow_yn === "y"}
                      onClick={() => {
                        item.follow_yn === "y"
                          ? store_unfollow(Number(item.store_seq))
                          : store_follow(Number(item.store_seq));
                      }}
                    >
                      {item.follow_yn === "y" ? "팔로잉" : "팔로우"}
                    </FollowBtn>
                  )}
                </StoreInfo>
              )}
            </div>
          );
        })}
    </LiveListDiv>
  );
};

export default LiveList;

const LiveListDiv = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 50%); /* 2열로 배치 */
  gap: 16px;
  padding: 16px 0px;
  color: var(--user-text);
  margin-right: 16px;
`;

const Thimbnail = styled.div<{ $isLive: boolean }>`
  position: relative;
  overflow: hidden;
  background-size: ${props => props.$isLive ? "cover" : "contain"};
  background-position: center;
  background-repeat: no-repeat;
  background-color: #2d2d2d;
  width: 100%;
  aspect-ratio: 9/10; /* 일정한 비율 유지 */
  border-radius: 8px;
  box-sizing: border-box;
  padding: 8px;
  cursor: pointer;
`;

const CardOverlay = styled.div`
  position: relative;
  z-index: 1;
  color: white;
  pointer-events: none;
`;

const ViewCount = styled.div`
  background-color: black;
  padding: 0px 6px;
  height: 20px;
  line-height: 20px; /* 높이와 동일하게 설정하여 수직 가운데 정렬 */
  border-radius: 4px;
  font-size: 12px;
  margin-left: 5px;
  display: inline-block; /* 한 줄 텍스트를 위한 설정 */
  overflow: hidden; /* 넘치는 텍스트 숨김 */
  text-overflow: ellipsis; /* 넘치는 텍스트를 ...으로 표시 */
  white-space: nowrap; /* 텍스트를 한 줄로 유지 */
  text-align: center; /* 수평 가운데 정렬 */
`;

const Title = styled.div`
  font-size: 16px;
  font-family: var(--font-Pretendard-Bold);
  margin-top: 10px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const StoreInfo = styled.div`
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const ProfileDiv = styled(RowView)`
  max-width: 100%;
  overflow: hidden;
  justify-content: flex-start;
`;

const Nickname = styled.div`
  max-width: 75%; /* 최대 너비 설정 */
  display: inline-block; /* 한 줄 텍스트를 위한 설정 */
  overflow: hidden; /* 넘치는 텍스트 숨김 */
  text-overflow: ellipsis; /* 넘치는 텍스트를 ...으로 표시 */
  white-space: nowrap; /* 텍스트를 한 줄로 유지 */
`;

const ProfileImage = styled.img`
  width: 24px;
  height: 24px;
  border-radius: 100px;
  margin-right: 5px;
`;

const FollowBtn = styled.div<{ $isFollowing: boolean }>`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 58px;
  height: 26px;
  border-radius: 6px;
  font-size: 12px;
  font-family: var(--font-Pretendard-Medium);
  box-sizing: border-box;
  user-select: none;
  transition: all 0.2s ease;

  ${(props) =>
    props.$isFollowing
      ? `
        background-color: transparent;
        border: 1px solid var(--user-border);
        color: var(--user-text-muted);
      `
      : `
        background: linear-gradient(135deg, #7955F0, #3209B9);
        border: none;
        color: white;
        font-family: var(--font-Pretendard-Bold);
      `}
`;
